export class ClothesModel {

    codBaan: string;
    descrp: string;
    grupoSz: string;
    punit: number;

    constructor() { }
}